import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import React from "react";
var __jsx = React.createElement;
import { useFormContext, Controller } from "react-hook-form";
import { RadioGroup } from "@syarahtech/ui";
import { twMerge } from "tailwind-merge";
import { useTranslation } from "@i18n";
var RHFRadioGroup = function RHFRadioGroup(_ref) {
  var name = _ref.name,
    options = _ref.options,
    defaultValue = _ref.defaultValue,
    direction = _ref.direction,
    _onChange = _ref.onChange,
    className = _ref.className;
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement(Controller, {
    name: name,
    control: control,
    defaultValue: defaultValue,
    render: function render(_ref2) {
      var field = _ref2.field,
        error = _ref2.fieldState.error;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RadioGroup, _extends({}, field, {
        dir: direction
      }), options === null || options === void 0 ? void 0 : options.map(function (option) {
        return /*#__PURE__*/React.createElement("label", {
          key: option.value,
          className: twMerge("flex gap-3 align-center px-3 py-4 rounded border border-solid border-gray-gainsboro text-gray-text text-sm font-medium items-center hover:border-primary hover:bg-neutral-0 transition ease-in transition-200 cursor-pointer", className),
          "aria-selected": field.value === option.value
        }, /*#__PURE__*/React.createElement("div", {
          className: "relative flex items-center justify-center"
        }, /*#__PURE__*/React.createElement("input", {
          type: "radio",
          value: option.value,
          checked: field.value === option.value,
          onChange: function onChange() {
            field.onChange(option.value);
            _onChange(option.value);
          },
          className: "peer appearance-none w-6 h-6 rounded-full border border-solid border-primary shrink-0 m-0"
        }), /*#__PURE__*/React.createElement("div", {
          className: "hidden absolute w-3 h-3 bg-primary rounded-full peer-checked:block"
        })), option.label);
      })), error && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "text-danger"
      }, tShort(error.message, {
        ns: "validations"
      }))));
    }
  });
};
export default RHFRadioGroup;